import { render, staticRenderFns } from "./alert.vue?vue&type=template&id=26645386&scoped=true&"
import script from "./alert.vue?vue&type=script&lang=ts&"
export * from "./alert.vue?vue&type=script&lang=ts&"
import style0 from "./alert.vue?vue&type=style&index=0&id=26645386&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26645386",
  null
  
)

export default component.exports